var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarImagePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "126px",
    height: "126px",
    viewBox: "0 0 126 126",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8E6ED195-2181-45E2-BFB2-D0A8DC91BFB6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 58,
    cy: 58,
    r: 58
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.6%",
    y: "-6.5%",
    width: "114.7%",
    height: "114.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.12 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "My-Profile---Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Customer-Portal---Desktop---My-Profile---Image-Placeholder",
    transform: "translate(-659.000000, -275.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(420.000000, 272.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Avatar",
    transform: "translate(235.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Avatar_image_placeholder",
    transform: "translate(7.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#E1E4E8",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.276426,70.7259468 C80.6412714,74.8346336 93,93.5425643 93,116 L22,116 C22,93.5425643 34.3587286,74.8346336 50.723574,70.7259468 C40.2928919,67.778526 32.65,58.1961923 32.65,46.8301887 C32.65,33.1168541 43.7757241,22 57.5,22 C71.2242759,22 82.35,33.1168541 82.35,46.8301887 C82.35,58.1961923 74.7071081,67.778526 64.2764352,70.7259493 L64.276426,70.7259468 Z",
    id: "path-1",
    fill: "#B0B7C3",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarImagePlaceholder);
export default __webpack_public_path__ + "static/media/avatar_image_placeholder.8e9bbd34959a174708cda969e761ff5c.svg";
export { ForwardRef as ReactComponent };